export enum RoutesUrl {
  //MAIN = 'main',
  //CALENDAR = 'calendario',
  //POSITIONS_TABLE = 'tabla-posiciones',
    // Rutas del Layout Principal
  MAIN = 'main',
  LOGIN = 'login',

  PORTAL = 'portal',
  PORTAL_TORNEO = 'torneo',
  PORTAL_RESULTADOS = 'resultados',
  PORTAL_DETALLEEQUIPO = 'equipo',
  PORTAL_MARCADORES = 'marcadores',
  PORTAL_ARBITRAJE_ESTADISTICAS = 'arbitraje/estadisticas',
  PORTAL_CAMPEONES = 'campeones',
  PORTAL_JUGADOR = 'jugador',
  PORTAL_JUGADOR_ACTUALIZAR = 'actualizar',
  PORTAL_CALENDARIO = 'calendario',
  PORTAL_VALIDAR_ROSTER = 'validar-roster',

  // Módulos dentro del Layout Principal
  DASHBOARD = 'dashboard',
  DASHBOARD_ROOT = 'dashboard/root',
  DASHBOARD_RESUMEN = 'dashboard/resumen',
  DASHBOARD_ALUMNOS = 'dashboard/alumnos',
  DASHBOARD_CRM = 'dashboard/crm',
  DASHBOARD_FINANCIERO = 'dashboard/financiero',
  TORNEOS = 'torneos',
  ARBITROS = 'arbitros',

  EQUIPOS = 'equipos',
  ESCUELAS = 'escuelas',
  LIGAS = 'ligas-config',
  MIEQUIPO = 'mi-equipo',
  MISJUGADORES = 'mis-jugadores',
  FAMILIAS = 'familias',
  JUGADORES = 'jugadores',
  ALUMNOS = 'alumnos',
  FAMILIAS_ALUMNOS = 'familias-alumnos',

  SEDES = 'sedes',
  CONFIGURACION = 'configuracion',
  
  REPORTES = 'reportes',     
  REPORTES_MARC_ID = 'reportes/marcadores/por-id',
  REPORTES_MARC_SEDE = 'reportes/marcadores/por-sede',
  REPORTES_MARC_CATEGORIA = 'reportes/marcadores/por-categoria',
  REPORTES_MARC_FECHA = 'reportes/marcadores/por-fecha',
  REPORTES_MARC_INCIDENCIAS = 'reportes/marcadores/incidencias',
  REPORTES_MARC_TIPO = 'reportes/marcadores/por-tipo',
  REPORTES_MARC_EQUIPO = 'reportes/marcadores/por-equipo',
  REPORTES_EQ_PARTIDOS = 'reportes/equipos/partidos',

  //FINANCIERO EQUIPOS
  FINEQ = 'fineq',
  FIN_DESCUENTOS = 'fineq/catalogos/descuentos',
  FIN_CUENTAS = 'fineq/catalogos/cuentas',
  FIN_CONCEPTOS = 'fineq/catalogos/conceptos',
  FIN_INGRESOS = 'fineq/operacion/ingresos',
  FIN_EGRESOS = 'fineq/operacion/egresos',
  FIN_CARGOS = 'fineq/operacion/cargos',
  FIN_COMISIONES = 'fineq/operacion/comisiones',
  FIN_SALDOS = 'fineq/operacion/saldos',
  FIN_FACTURAS = 'fineq/operacion/facturas',

  //FINANCIERO LIGA (solo GLOBAL)
  FINLI = 'finli',
  FINLI_CUENTAS = 'finli/catalogos/cuentas',
  FINLI_CONCEPTOS = 'finli/catalogos/conceptos',
  FINLI_DESCUENTOS = 'finli/catalogos/descuentos',
  FINLI_MULTAS = 'finli/catalogos/multas',
  FINLI_INGRESOS = 'finli/operacion/ingresos',
  FINLI_EGRESOS = 'finli/operacion/egresos',
  FINLI_SALDOS_EQUIPOS = 'finli/operacion/saldos-equipos',

  //CRM LIGA
  CRMLI = 'crmli',

  DOCS = 'documentos',

  NOTICIAS = 'news',
  NOTICIA_TAGS_GLOBALES = 'news-tags-globales',

  MISTAFF = 'mi-staff',

  CRM = 'crm',

  USUARIOS_ADMIN = 'usuarios-admin',

  ROLES_ESCUELA = 'roles-escuela',

  NIVELES_GRADOS = 'config/niveles-y-grados',
  CICLOS_Y_GRUPOS = 'academico/ciclos-y-grupos',

  CATEGORIAS_DIVISIONES = 'categorias-divisiones'
}
